module.exports = __webpack_public_path__ + "img/56.1.80fd84dd.jpg";